module.exports = __webpack_public_path__ + "static/media/dropbox.ef64267a.svg";